import type { SVGProps } from 'react';
const SvgSettingsInputComposite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#settings_input_composite_svg__a)">
      <path
        fill="currentColor"
        d="M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2Zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2Zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2ZM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2Zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2Zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2Z"
      />
    </g>
    <defs>
      <clipPath id="settings_input_composite_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettingsInputComposite;
